import type { BanDich } from '../types';
import type { viHanMucAi } from './han-muc-ai.vi';

/** Strings of the AI quota notice (`components/shared/ThongBaoHetHanMuc.tsx`). */
export const enHanMucAi: Pick<BanDich, keyof typeof viHanMucAi> = {
  hanMucAi: {
    tieuDe: {
      hetGoi: "This month's AI token quota is used up",
      hetGoiBiCat: "This month's AI token quota just ran out",
      hetToChuc: "The organization's AI quota is used up",
      hetKy: 'The AI usage quota for this period is used up',
      vuotPhongBan: '{{ten}} has used up its AI quota {{ky}}',
      vuotPhongBanCuaBan: 'Your department has used up its AI quota {{ky}}',
      vuotNguoi: 'You have used up your AI quota {{ky}}',
      khongDuNoiDung: 'Not enough AI tokens for the content sent',
      khongDuKetQua: 'Not enough AI tokens left for the result',
      khongDuBanGhi: 'Not enough AI tokens for this recording',
      chuaKiem: "Couldn't check the AI token quota",
    },
    ky: { ngay: 'today', tuan: 'this week', thang: 'this month' },
    daDung: '{{daDung}} / {{hanMuc}} tokens used',
    can: 'Needs {{so}} tokens',
    canItNhat: 'Needs at least {{so}} tokens',
    conToChuc: 'The organization has {{so}} tokens left this month',
    conPhongBan: '{{ten}} has {{so}} tokens left {{ky}}',
    conPhongBanCuaBan: 'Your department has {{so}} tokens left {{ky}}',
    conNguoi: 'You have {{so}} tokens left {{ky}}',
    tinhNang: 'Quota for the {{ten}} feature',
    moLai: 'Reopens at {{gio}} on {{ngay}}',
    moLaiNgan: 'Reopens {{gio}} {{ngay}}',
    canConNgan: 'Needs {{can}} · {{con}} tokens left',
    biCat: 'The run stopped partway through.',
    chuaChepLoi: "This recording hasn't been transcribed.",
    chuaTomTat: "The minutes couldn't be summarized.",
    banChepConDung: 'The transcript is still available.',
    khacVanDung: 'Other features keep working as usual.',
    chuaGoiDuocAi: "AI can't be called right now. Try again in a few minutes.",
    heThongThuLai: 'The system will retry. If it still fails, try again in a few minutes.',
    lienHeNenTang: 'Contact the platform admin to raise the quota.',
    lienHeToChuc: 'To get more, contact your organization admin.',
    lienHeQuanTri: 'Contact your admin to raise the quota.',
    goiYNoiDungNenTang: 'Send less content (fewer pages or documents), or contact the platform admin to raise the quota.',
    goiYNoiDungToChuc: 'Send less content, or contact your organization admin.',
    goiYBanGhiNenTang: 'Shorten the recording, or contact the platform admin to raise the quota.',
    goiYBanGhiToChuc: 'Shorten the recording, or contact your organization admin.',
    khiCoThem: 'Once more quota is available, select {{nut}}.',
    boQuaTieuDe: 'File loaded, AI heading step skipped',
    boQuaTieuDeMo: 'Chunking may be less accurate. Reload the file once this is resolved for better chunks.',
    maLoi: 'Error code: {{ma}}',
  },
};
